import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';

/* Services */

import { ClienteService } from '../../core/services/clientes/cliente.service';
import { ConfiguracaoService } from '../../core/services/configuracoes/configuracao.service';
import { NovoInteresseService } from '../../core/services/novos-interesses/novo-interesse.service';
import { ExcelService } from '../../core/tools/excel.service';

/* Models */

import { Cliente } from '../../core/models/clientes/cliente';
import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { NovoInteresseContato } from '../../core/models/novos-interesses/novo-interesse-contato';

export interface FiltroAtivo {
  tipo: string;
  valor: string;
}

@Component({
    selector: 'app-clientes',
    templateUrl: './clientes.component.html',
    styleUrls: ['./clientes.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class ClientesComponent implements OnInit {
  fotoCorrecaoGeoUrl = '';
  fotoCorrecaoGeoCliente = '';
  erroFotoCorrecaoGeo = false;

  verFotoCorrecaoGeo(cliente: Cliente, template: TemplateRef<unknown>) {
    const arquivo = cliente.foto_correcao_posicao?.trim();
    if (!arquivo) return;
    this.fotoCorrecaoGeoUrl = 'https://crmarquivos.blob.core.windows.net/appfotocorrecaogeo/' + arquivo.split('/').map(encodeURIComponent).join('/');
    this.fotoCorrecaoGeoCliente = cliente.name;
    this.erroFotoCorrecaoGeo = false;
    this.modalService.open(template, { size: 'lg', centered: true, ariaLabelledBy: 'titulo-foto-correcao-geo' });
  }

  /* Carregamento */

  carregando: boolean = false;

  exportando: boolean = false;

  /* Filtros (Multiplos) */

  formFiltroCliente: UntypedFormGroup;

  filtroClientes: any[] = [];

  enviadoCliente: boolean = false;

  filtrandoCliente: boolean = false;

  filtrosAtivosClientes: FiltroAtivo[] = [];

  opcoesPorCampoCliente: { [campo: string]: string[] } = {};

  /* Clientes */

  clientes: Cliente[] = [];

  contagemTipos = { cadastrados: 0, efetivadosACadastrar: 0, leads: 0, interessadosB2B: 0 };

  configuracao: Configuracao = null;

  arquivoImportacaoLeads: File = null;
  importandoLeads: boolean = false;
  resultadoImportacaoLeads: any = null;

  /* Interessados B2B */

  interessadosB2B: NovoInteresseContato[] = [];
  filtroContatadoInteressadoB2B: string = 'todos';

  /* Paginacao */

  page: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;
  totalPages: number = 0;

  /* Tabs */

  tabSelecionada: string = 'cadastrados';

  /* Status Integracao */

  clienteStatusSelecionado: Cliente = null;
  carregandoStatusIntegracao: boolean = false;
  statusIntegracaoCliente: { id: number; status: string; data: Date }[] = [];

  /* Storage */

  is_master: boolean = (localStorage.getItem("is_master") == "true");
  is_diretor: boolean = (localStorage.getItem("is_diretor") == "true");
  token_innersac: string = localStorage.getItem("token_innersac");
  link_innersac: string = localStorage.getItem("link_innersac");

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private clienteService: ClienteService,
    private configuracaoService: ConfiguracaoService,
    private excelService: ExcelService,
    private novoInteresseService: NovoInteresseService
  ) { }

  ngOnInit() {
    this.formFiltroCliente = this.formBuilder.group({
      filtro: ['codigo', Validators.required],
      valor: ['', Validators.required]
    });

    this.carregarConfiguracao();

    // Carregar opcoes de filtro dinamicas e entao os dados
    this.clienteService.getClienteFiltrosConfigurados().subscribe(configClientes => {
      const filtrosFixos = [
        { texto: 'Código', valor: 'codigo' },
        { texto: 'CNPJ/CPF', valor: 'cnpj_cpf' },
        { texto: 'Nome Fantasia', valor: 'nome_fantasia' },
        { texto: 'Razão Social', valor: 'razao_social' },
        { texto: 'Responsável', valor: 'responsavel' },
      ];
      const filtrosDinamicos = (configClientes.filtros || []) as any[];
      const filtrosDinamicosComOpcoes = filtrosDinamicos
        .filter((f: any) => f.opcoes && f.opcoes.length > 0)
        .map((f: any) => ({ texto: f.label, valor: f.campo }));
      const filtrosExtras = [
        { texto: 'Cidade', valor: 'cidade' },
        { texto: 'Classificação', valor: 'classificacao' },
      ];
      this.filtroClientes = [...filtrosFixos, ...filtrosDinamicosComOpcoes, ...filtrosExtras];

      this.opcoesPorCampoCliente = {};
      filtrosDinamicos.forEach((f: any) => {
        this.opcoesPorCampoCliente[f.campo] = f.opcoes || [];
      });

      this.carregarClientes();
      this.carregarContagemTipos();
      this.carregarContagemInteressadosB2B();
    }, () => {
      // Fallback: carregar sem filtros dinamicos
      this.filtroClientes = [
        { texto: 'Código', valor: 'codigo' },
        { texto: 'CNPJ/CPF', valor: 'cnpj_cpf' },
        { texto: 'Nome Fantasia', valor: 'nome_fantasia' },
        { texto: 'Razão Social', valor: 'razao_social' },
        { texto: 'Responsável', valor: 'responsavel' },
        { texto: 'Cidade', valor: 'cidade' },
        { texto: 'Classificação', valor: 'classificacao' },
      ];
      this.carregarClientes();
      this.carregarContagemTipos();
      this.carregarContagemInteressadosB2B();
    });
  }

  get fc() {
    return this.formFiltroCliente.controls;
  }

  carregarConfiguracao() {
    this.configuracaoService.getByGuidClienteNapis().subscribe(
      configuracao => this.configuracao = configuracao,
      error => { console.log("Erro: " + error); }
    );
  }

  get podeImportarLeads(): boolean {
    return this.tabSelecionada == 'leads' && this.configuracao != null && this.configuracao.flag_exibir_importarleads_menucadastro == true;
  }

  /* Acoes */

  alterarCliente(client_id_app: number) {
    this.router.navigate(["/clientes-cadastro/" + client_id_app]);
  }

  possuiErroIntegracao(cliente: Cliente): boolean {
    return (cliente.flag_erro_integracao_cliente || '').toUpperCase() == 'S';
  }

  abrirStatusIntegracaoCliente(cliente: Cliente, modalStatus: any) {
    this.clienteStatusSelecionado = cliente;
    this.statusIntegracaoCliente = [];
    this.carregandoStatusIntegracao = true;

    this.modalService.open(modalStatus, { size: 'lg', centered: true });

    this.clienteService.getStatusIntegracaoCliente(cliente.id).subscribe(
      resultado => {
        this.statusIntegracaoCliente = resultado || [];
        this.carregandoStatusIntegracao = false;
      },
      error => {
        console.log("Erro: " + error);
        this.carregandoStatusIntegracao = false;
      }
    );
  }

  reintegrarCliente(cliente: Cliente) {
    this.clienteService.reintegrarCliente(cliente.id).subscribe(
      resultado => {
        if (resultado) {
          cliente.flag_erro_integracao_cliente = null;
          this.carregarClientes();
          this.carregarContagemTipos();
          this.toastr.success("", "Cliente liberado para reintegração!");
        }
      },
      error => { console.log("Erro: " + error); }
    );
  }

  efetivarCadastro(client_id_app: number) {
    let alterarCadastroEfetivado: boolean = false;

    this.clienteService.updateCadastroEfetivadoById(client_id_app, true).subscribe(
      alterarCadastrosEfetivados => alterarCadastroEfetivado = alterarCadastrosEfetivados,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarCadastroEfetivado) {
          this.carregarClientes();
          this.toastr.success("", "Cadastro efetivado com sucesso!");
        }
      }
    );
  }

  desativarCadastro(client_id_app: number) {
    let desativarCadastro: boolean = false;

    this.clienteService.updateIsActiveById(client_id_app, false).subscribe(
      desativarCadastros => desativarCadastro = desativarCadastros,
      error => { console.log("Erro: " + error) },
      () => {
        if (desativarCadastro) {
          this.carregarClientes();
          this.toastr.success("", "Cadastro desativado com sucesso!");
        }
      }
    );
  }

  novoCliente() {
    this.router.navigate(["/clientes-cadastro"]);
  }

  /* Dados */

  carregarClientes() {
    if (this.tabSelecionada == 'interessadosB2B') {
      this.carregarInteressadosB2B();
      return;
    }

    this.carregando = true;

    const filtros: FiltroAtivo[] = [];

    // Filtro de tipo de cliente pela aba ativa
    const tipoMap: { [key: string]: string } = {
      'cadastrados': 'cadastrado',
      'efetivados': 'efetivado',
      'leads': 'lead'
    };
    filtros.push({ tipo: 'tipo_cliente', valor: tipoMap[this.tabSelecionada] || 'cadastrado' });

    // Incluir inativos para master e diretor
    if (this.is_master || this.is_diretor) {
      filtros.push({ tipo: 'inativos', valor: 'true' });
    }

    // Incluir filtros ativos
    filtros.push(...this.filtrosAtivosClientes);

    this.clienteService.searchPaged(filtros, this.page - 1, this.pageSize).subscribe(
      resultado => {
        this.clientes = resultado.items;
        this.totalItems = resultado.total;
        this.totalPages = Math.ceil(resultado.total / this.pageSize);
      },
      error => { console.log("Erro: " + error); this.carregando = false; },
      () => {
        this.clientes.forEach((item) => {
          const inicioCodigo: string = item.codigo_no_erp_do_cliente != null ? item.codigo_no_erp_do_cliente.substring(0, 4) : "";
          if ((item.codigo_no_erp_do_cliente == null || inicioCodigo == "NOVO") && item.client_document != null && item.flag_novo_cliente == 'S' && !item.cadastro_efetivado) {
            item.efetivado = false;
          } else {
            item.efetivado = true;
          }
        });
        this.carregando = false;
      }
    );
  }

  exportar() {
    // Exportacao nao se aplica a aba de interessados B2B (origem de dados distinta).
    if (this.tabSelecionada == 'interessadosB2B') {
      return;
    }

    this.exportando = true;

    const filtros: FiltroAtivo[] = [];

    // Mesma montagem de filtros da listagem, para o Excel refletir exatamente a tela.
    const tipoMap: { [key: string]: string } = {
      'cadastrados': 'cadastrado',
      'efetivados': 'efetivado',
      'leads': 'lead'
    };
    filtros.push({ tipo: 'tipo_cliente', valor: tipoMap[this.tabSelecionada] || 'cadastrado' });

    if (this.is_master || this.is_diretor) {
      filtros.push({ tipo: 'inativos', valor: 'true' });
    }

    filtros.push(...this.filtrosAtivosClientes);

    this.clienteService.exportarExcel(filtros, this.tabSelecionada).subscribe(
      (blob: Blob) => {
        const hoje = new Date();
        const sufixo = `${hoje.getFullYear()}${('0' + (hoje.getMonth() + 1)).slice(-2)}${('0' + hoje.getDate()).slice(-2)}`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `clientes_${this.tabSelecionada}_${sufixo}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.exportando = false;
      },
      async (error: any) => {
        let msg: string | null = null;
        try {
          if (error && error.error instanceof Blob) {
            const texto = await error.error.text();
            const json = JSON.parse(texto);
            msg = json && json.message ? json.message : null;
          }
        } catch { }

        if (msg) {
          this.toastr.warning(msg, "Aviso");
        } else {
          this.toastr.error("", "Houve um erro ao exportar, contate o suporte...");
        }
        this.exportando = false;
      }
    );
  }

  abrirImportacaoLeads(modalImportacaoLeads: any) {
    this.arquivoImportacaoLeads = null;
    this.importandoLeads = false;
    this.resultadoImportacaoLeads = null;
    this.modalService.open(modalImportacaoLeads, { size: 'xl', centered: true, backdrop: 'static' });
  }

  baixarModeloImportacaoLeads() {
    this.excelService.exportAsExcelFile([
      {
        codvenderp: "",
        razaosocial: "",
        cnpj: "",
        ie: "",
        ativo: "S",
        logradouro: "",
        endereco: "",
        endnumero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        estado: "",
        cep: "",
        fone: "",
        email: "",
        responsavel: "",
        gruporegiao: "",
        segmento: "",
        lat: "",
        long: ""
      }
    ], "modelo_importacao_leads");
  }

  selecionarArquivoImportacaoLeads(event: any) {
    this.arquivoImportacaoLeads = event && event.target && event.target.files && event.target.files.length > 0
      ? event.target.files[0]
      : null;
    this.resultadoImportacaoLeads = null;
  }

  async processarImportacaoLeads() {
    if (this.arquivoImportacaoLeads == null) {
      this.toastr.warning("", "Selecione uma planilha para importar.");
      return;
    }

    const nomeArquivo = (this.arquivoImportacaoLeads.name || "").toLowerCase();
    if (!nomeArquivo.endsWith(".xlsx") && !nomeArquivo.endsWith(".xls")) {
      this.toastr.error("", "Selecione um arquivo de planilha (.xlsx ou .xls).");
      return;
    }

    this.importandoLeads = true;

    let chamouApi = false;

    try {
      const conteudo = await this.lerArquivoComoBinario(this.arquivoImportacaoLeads);
      const linhasExcel = this.excelService.importExcelBinaryToJson(conteudo) || [];
      const linhas = linhasExcel
        .map((linhaExcel: any, index: number) => this.mapearLinhaImportacaoLead(linhaExcel, index + 2))
        .filter((linha: any) => this.linhaImportacaoLeadPreenchida(linha));

      if (linhas.length == 0) {
        this.resultadoImportacaoLeads = {
          total_linhas: 0,
          importados: 0,
          importados_com_aviso: 0,
          erros: 1,
          geolocalizados: 0,
          sem_geolocalizacao: 0,
          vendedores: [],
          itens: [{ linha: 0, status: "Erro", detalhe: "Nenhuma linha válida encontrada na planilha." }]
        };
        return;
      }

      if (linhas.length > 50) {
        this.resultadoImportacaoLeads = {
          total_linhas: linhas.length,
          importados: 0,
          importados_com_aviso: 0,
          erros: 1,
          geolocalizados: 0,
          sem_geolocalizacao: 0,
          vendedores: [],
          itens: [{ linha: 0, status: "Erro", detalhe: "A planilha possui mais de 50 leads. Importe no máximo 50 leads por vez." }]
        };
        return;
      }

      for (const linha of linhas) {
        await this.prepararGeolocalizacaoLead(linha);
      }

      chamouApi = true;
      this.clienteService.importarLeads(linhas).subscribe(
        resultado => {
          this.resultadoImportacaoLeads = resultado;
          if (resultado != null) {
            this.carregarClientes();
            this.carregarContagemTipos();
            this.toastr.success("", "Importação processada.");
          }
          this.importandoLeads = false;
        },
        error => {
          console.log("Erro: " + error);
          this.importandoLeads = false;
        }
      );
    } catch (error) {
      console.log(error);
      this.toastr.error("", "Erro ao ler a planilha.");
    } finally {
      if (!chamouApi) {
        this.importandoLeads = false;
      }
    }
  }

  private lerArquivoComoBinario(arquivo: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(reader.error);
      reader.readAsBinaryString(arquivo);
    });
  }

  private mapearLinhaImportacaoLead(linhaExcel: any, linha: number): any {
    return {
      linha: linha,
      codvenderp: this.obterValorLinhaExcel(linhaExcel, ["codvenderp", "codvendedor", "cod vendedor"]),
      razaosocial: this.obterValorLinhaExcel(linhaExcel, ["razaosocial", "razao social", "razão social"]),
      cnpj: this.obterValorLinhaExcel(linhaExcel, ["cnpj", "cpf", "cnpj cpf", "cpf cnpj"]),
      ie: this.obterValorLinhaExcel(linhaExcel, ["ie", "inscricao estadual", "inscrição estadual"]),
      ativo: this.converterAtivoImportacaoLead(this.obterValorLinhaExcel(linhaExcel, ["ativo"])),
      logradouro: this.obterValorLinhaExcel(linhaExcel, ["logradouro"]),
      endereco: this.obterValorLinhaExcel(linhaExcel, ["endereco", "endereço"]),
      endnumero: this.obterValorLinhaExcel(linhaExcel, ["endnumero", "end numero", "numero", "número"]),
      complemento: this.obterValorLinhaExcel(linhaExcel, ["complemento"]),
      bairro: this.obterValorLinhaExcel(linhaExcel, ["bairro"]),
      cidade: this.obterValorLinhaExcel(linhaExcel, ["cidade"]),
      estado: this.obterValorLinhaExcel(linhaExcel, ["estado", "uf"]),
      cep: this.obterValorLinhaExcel(linhaExcel, ["cep"]),
      fone: this.obterValorLinhaExcel(linhaExcel, ["fone", "telefone", "phone"]),
      email: this.obterValorLinhaExcel(linhaExcel, ["email", "e-mail"]),
      responsavel: this.obterValorLinhaExcel(linhaExcel, ["responsavel", "responsável"]),
      gruporegiao: this.obterValorLinhaExcel(linhaExcel, ["gruporegiao", "grupo regiao", "grupo região"]),
      segmento: this.obterValorLinhaExcel(linhaExcel, ["segmento"]),
      lat: this.converterNumeroImportacaoLead(this.obterValorLinhaExcel(linhaExcel, ["lat", "latitude"])),
      lon: this.converterNumeroImportacaoLead(this.obterValorLinhaExcel(linhaExcel, ["long", "lon", "longitude"])),
      aviso_geolocalizacao: ""
    };
  }

  private linhaImportacaoLeadPreenchida(linha: any): boolean {
    return Object.keys(linha).some(chave => chave != "linha" && chave != "ativo" && chave != "lat" && chave != "lon" && chave != "aviso_geolocalizacao" && linha[chave] != null && linha[chave].toString().trim() != "");
  }

  private obterValorLinhaExcel(linhaExcel: any, nomes: string[]): string {
    const chaves = Object.keys(linhaExcel || {});

    for (const nome of nomes) {
      const chave = chaves.find(c => this.normalizarCabecalhoImportacaoLead(c) == this.normalizarCabecalhoImportacaoLead(nome));
      if (chave != null && linhaExcel[chave] != null) {
        return linhaExcel[chave].toString().trim();
      }
    }

    return "";
  }

  private normalizarCabecalhoImportacaoLead(valor: string): string {
    return (valor || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toLowerCase();
  }

  private converterAtivoImportacaoLead(valor: string): boolean {
    const normalizado = (valor || "").trim().toUpperCase();

    if (normalizado == "N" || normalizado == "NAO" || normalizado == "NÃO" || normalizado == "0" || normalizado == "FALSE") {
      return false;
    }

    return true;
  }

  private converterNumeroImportacaoLead(valor: string): number {
    if (valor == null || valor.toString().trim() == "") {
      return null;
    }

    const numero = Number(valor.toString().replace(",", "."));

    return isNaN(numero) ? null : numero;
  }

  private gpsImportacaoLeadValido(valor: number): boolean {
    return valor != null && valor != 0 && valor != -1;
  }

  private async prepararGeolocalizacaoLead(linha: any): Promise<void> {
    if (this.gpsImportacaoLeadValido(linha.lat) && this.gpsImportacaoLeadValido(linha.lon)) {
      return;
    }

    const endereco = [linha.logradouro, linha.endereco, linha.endnumero, linha.bairro, linha.cidade, linha.estado, linha.cep]
      .filter(item => item != null && item.toString().trim() != "")
      .join(", ");

    if (endereco.trim() == "") {
      linha.lat = -1;
      linha.lon = -1;
      linha.aviso_geolocalizacao = "Geolocalização não informada e endereço insuficiente para buscar coordenadas.";
      return;
    }

    const googleApi = (window as any).google;
    if (googleApi == null || googleApi.maps == null || googleApi.maps.Geocoder == null) {
      linha.lat = -1;
      linha.lon = -1;
      linha.aviso_geolocalizacao = "Geolocalização não informada e Google Maps indisponível para buscar coordenadas.";
      return;
    }

    const geocoder = new googleApi.maps.Geocoder();

    try {
      const coordenadas: any = await new Promise(resolve => {
        geocoder.geocode({ address: endereco }, (results: any[], status: string) => {
          if (status == "OK" && results != null && results.length > 0) {
            resolve({
              lat: results[0].geometry.location.lat(),
              lon: results[0].geometry.location.lng()
            });
          } else {
            resolve(null);
          }
        });
      });

      if (coordenadas == null) {
        linha.lat = -1;
        linha.lon = -1;
        linha.aviso_geolocalizacao = "Não foi possível localizar o endereço. Lead importado com coordenadas -1.";
      } else {
        linha.lat = coordenadas.lat;
        linha.lon = coordenadas.lon;
      }
    } catch {
      linha.lat = -1;
      linha.lon = -1;
      linha.aviso_geolocalizacao = "Falha ao buscar geolocalização. Lead importado com coordenadas -1.";
    }
  }

  alterarAbas(event: any) {
    this.tabSelecionada = event.nextId;
    this.page = 1;
    this.filtrosAtivosClientes = [];

    if (this.tabSelecionada == 'interessadosB2B') {
      this.carregarInteressadosB2B();
    } else {
      this.carregarClientes();
    }
  }

  carregarContagemTipos() {
    this.clienteService.getContagemTipos().subscribe(
      resultado => {
        this.contagemTipos.cadastrados = resultado.cadastrados;
        this.contagemTipos.efetivadosACadastrar = resultado.efetivadosACadastrar;
        this.contagemTipos.leads = resultado.leads;
      },
      error => { console.log("Erro: " + error); }
    );
  }

  carregarContagemInteressadosB2B() {
    this.novoInteresseService.getContatosByGuidClienteNapis().subscribe(
      resultado => { this.contagemTipos.interessadosB2B = (resultado || []).length; },
      error => { console.log("Erro: " + error); }
    );
  }

  carregarInteressadosB2B() {
    this.carregando = true;

    this.novoInteresseService.getContatosByGuidClienteNapis().subscribe(
      resultado => {
        this.interessadosB2B = this.ordenarInteressadosB2B(resultado || []);
        this.contagemTipos.interessadosB2B = this.interessadosB2B.length;
        this.atualizarPaginacaoInteressadosB2B();
      },
      error => { console.log("Erro: " + error); this.carregando = false; },
      () => { this.carregando = false; }
    );
  }

  alterarFiltroContatadoInteressadoB2B() {
    this.page = 1;
    this.atualizarPaginacaoInteressadosB2B();
  }

  atualizarContatoInteressadoB2B(interessado: NovoInteresseContato, contatado: boolean) {
    this.novoInteresseService.updateContatoContatado(interessado.id, contatado).subscribe(
      resultado => {
        if (resultado) {
          interessado.contatado = contatado;
          this.interessadosB2B = this.ordenarInteressadosB2B(this.interessadosB2B);
          this.atualizarPaginacaoInteressadosB2B();
          this.toastr.success("", contatado ? "Interessado marcado como contatado!" : "Interessado removido de contatado!");
        }
      },
      error => { console.log("Erro: " + error); }
    );
  }

  get interessadosB2BFiltrados(): NovoInteresseContato[] {
    if (this.filtroContatadoInteressadoB2B == 'contatado') {
      return this.interessadosB2B.filter(interessado => interessado.contatado);
    }

    if (this.filtroContatadoInteressadoB2B == 'nao_contatado') {
      return this.interessadosB2B.filter(interessado => !interessado.contatado);
    }

    return this.interessadosB2B;
  }

  get interessadosB2BPaginados(): NovoInteresseContato[] {
    const inicio = (this.page - 1) * this.pageSize;
    return this.interessadosB2BFiltrados.slice(inicio, inicio + this.pageSize);
  }

  private atualizarPaginacaoInteressadosB2B() {
    this.totalItems = this.interessadosB2BFiltrados.length;
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
  }

  private ordenarInteressadosB2B(interessados: NovoInteresseContato[]): NovoInteresseContato[] {
    return [...interessados].sort((a, b) => {
      return new Date(b.data_cadastro).getTime() - new Date(a.data_cadastro).getTime();
    });
  }

  /* Filtros (Multiplos) */

  alterarFiltroProdutoCliente(filtro_selecionado: string) {
    let filtroAtual: string = this.formFiltroCliente.controls['filtro'].value;

    this.formFiltroCliente.reset();

    if (filtro_selecionado == null) {
      this.formFiltroCliente.controls['filtro'].setValue(filtroAtual);
    } else {
      this.formFiltroCliente.controls['filtro'].setValue(filtro_selecionado);
    }

    this.enviadoCliente = false;
  }

  adicionarFiltroCliente() {
    this.enviadoCliente = true;

    if (this.formFiltroCliente.invalid) {
      return;
    }

    const tipo = this.formFiltroCliente.get('filtro').value;
    const valor = this.formFiltroCliente.get('valor').value.trim();

    if (!tipo || !valor) {
      this.toastr.error("Tipo e valor são obrigatórios!", "Erro");
      return;
    }

    const jaExiste = this.filtrosAtivosClientes.some(f => f.tipo === tipo && f.valor.toLowerCase() === valor.toLowerCase());

    if (jaExiste) {
      this.toastr.warning("Este filtro já foi adicionado!", "Aviso");
      return;
    }

    this.filtrosAtivosClientes.push({ tipo, valor });

    this.formFiltroCliente.get('valor').reset();
    this.enviadoCliente = false;

    this.toastr.success("Filtro adicionado!", "Sucesso");
  }

  removerFiltroCliente(index: number) {
    this.filtrosAtivosClientes.splice(index, 1);
  }

  limparTodosFiltrosClientes() {
    this.filtrosAtivosClientes = [];
    this.formFiltroCliente.reset({ filtro: 'codigo', valor: '' });
    this.page = 1;
    this.carregarClientes();
    this.toastr.info("Filtros removidos!", "Informação");
  }

  aplicarFiltroClientePaginado() {
    this.page = 1;
    this.carregarClientes();
  }

  obterTextoFiltroCliente(tipo: string): string {
    const filtro = this.filtroClientes.find(f => f.valor === tipo);
    return filtro ? filtro.texto : tipo;
  }

  get opcoesValorFiltroCliente(): string[] {
    const campo = this.formFiltroCliente && this.formFiltroCliente.controls['filtro']
      ? this.formFiltroCliente.controls['filtro'].value
      : null;
    if (!campo) return [];
    return this.opcoesPorCampoCliente[campo] || [];
  }

  get filtroValorClienteEhSelect(): boolean {
    return this.opcoesValorFiltroCliente.length > 0;
  }

  /* Paginacao */

  onPageChange(page: number) {
    this.page = page;

    if (this.tabSelecionada != 'interessadosB2B') {
      this.carregarClientes();
    }
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.page = 1;

    if (this.tabSelecionada == 'interessadosB2B') {
      this.atualizarPaginacaoInteressadosB2B();
    } else {
      this.carregarClientes();
    }
  }

  /* Portal Compras */

  liberarPortalCompras(client_id_app: number, liberar: boolean) {
    let alterarSenha: boolean = false;

    this.clienteService.updatePasswordInicialById(client_id_app, liberar).subscribe(
      alterarSenhas => alterarSenha = alterarSenhas,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarSenha) {
          this.carregarClientes();

          if (liberar) {
            this.toastr.success("", "Cliente liberado!");
          } else {
            this.toastr.success("", "Cliente bloqueado!");
          }
        }
      }
    );
  }

  resetarSenhaPortalCompras(client_id_app: number) {
    let alterarSenha: boolean = false;

    this.clienteService.updatePasswordInicialById(client_id_app, true).subscribe(
      alterarSenhas => alterarSenha = alterarSenhas,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarSenha) {
          this.toastr.success("", "Senha resetada com sucesso!");
        }
      }
    );
  }

  /* Rotas */

  reiniciarGeolocalizacaoCliente(cliente_id_app: number) {
    let alterarGeolocalizacaoAntiga: boolean = false;

    this.clienteService.updateGeolocalizacaoAntigaById(cliente_id_app).subscribe(
      alterarGeolocalizacoesAntiga => alterarGeolocalizacaoAntiga = alterarGeolocalizacoesAntiga,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarGeolocalizacaoAntiga) {
          const cliente = this.clientes.find(c => c.client_id_app === cliente_id_app);
          if (cliente) {
            cliente.dt_correcao_posicao = null;
            cliente.foto_correcao_posicao = null;
          }
          this.toastr.success("", "Geolocalização reiniciada com sucesso!");
        }
      }
    );
  }

  /* Whatsapp */

  iniciarChat(dddWhatsApp: number, telefoneWhatsApp: number) {
    if (dddWhatsApp.toString().trim() == "") {
      this.toastr.error("", "WhatsApp (DDD) em branco!");
    } else if (telefoneWhatsApp.toString().trim() == "") {
      this.toastr.error("", "WhatsApp (Telefone) em branco!");
    } else {
      if (this.token_innersac != "" && this.link_innersac != "") {
        this.router.navigate(["/whatsapp-innersac/" + dddWhatsApp.toString().trim() + telefoneWhatsApp.toString().trim()]);
      }
    }
  }
}
